module.exports = "https://cdn.hellotech.com/client-assets/consult-modal-img-desktop_ed42a98dca2a4460a97835616b14e3cb.png";